  import React from 'react';
  import { useAuth } from '../../../hooks/useAuth';
  import styles from './Header.module.scss';
  

  interface HeaderProps {
    onMenuToggle?: () => void;
  }

  const Header: React.FC<HeaderProps> = ({ onMenuToggle }) => {
  const { auth, logout } = useAuth();

    const handleLogout = () => {
      logout();
    };

    return (
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          {onMenuToggle && (
            <button 
              className={styles.menuToggle}
              onClick={onMenuToggle}
              aria-label="Toggle menu"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          )}
          <div className={styles.logo}>
            {/* {logo ? (
              <>
                <img 
                  src={logo} 
                  alt={`Product Tracking logo`}
                  className={styles.logoImage}
                  style={{ borderRadius: '50%', width: '40px', height: '40px', objectFit: 'cover' }}
                />
                <span className={styles.logoText}>
                  {'Product Tracking'}
                </span>
              </>
            ) : ( */}
              <span className={styles.logoText}>
                {'MS LPG Agency'}
              </span>
            {/* )} */}
          </div>
        </div>
        <div className={styles.userInfo}>
          {auth.user && (
            <>
              <div className={styles.toolbar}>
                <span className={styles.employeeName}>
                  {auth.user?.name}
                </span>
              </div>
              <button onClick={handleLogout} className={styles.logoutBtn}>
                Logout
              </button>
            </>
          )}
        </div>
      </header>
    );
  };

  export default Header; 